import apiClient from './apiClient';
import {REFRESHTOKEN} from '../utils/ApiEndPoint';

export async function refreshJwtToken() {
  const refreshToken = localStorage.getItem('token'); // Or use sessionStorage/cookie

  if (!refreshToken) {
    throw new Error("No refresh token found. Please login again.");
  }

  try {
    // Call your backend refresh endpoint
    const user = JSON.parse(localStorage.getItem("user"));
    const {mobileNumber,hp}=user
    const response = await apiClient.post(REFRESHTOKEN, {mobile:mobileNumber,password:hp ,token:refreshToken });

    console.log("Refresh Token Response",response);
    user.token=response?.data?.token
    // Save new access token (and refresh token, if rotated) 
    localStorage.setItem('token', response?.data?.token);
    localStorage.setItem('user', JSON.stringify(user));
  
    return response.data.token;
  } catch (error) {
    // If refresh fails, you should log out the user
    localStorage.removeItem('token');
    throw new Error("Session expired. Please login again.");
  }
}
